import { Section } from '../../components/Section'
import { Container } from '../../components/Container'
import { UserDetail } from '../../containers/users/UserDetail'
import { useNavigate, useParams } from 'react-router'
import { useGetUser } from 'BrokerTsLib/src/hooks/useUser'
import { PageContent } from '../../containers/PageContent'
import { Loading } from '../../components/Loading'
import { PageAlert } from 'brokertslib/src/components/PageAlert'
import { Button, Stack } from '@chakra-ui/react'
import { ArrowLeft, Refresh } from '../../icons'

export const UserDetailPage = () => {
  const { userId } = useParams()
  const navigate = useNavigate()

  const { data, isLoading, isError, isSuccess, error, refetch } = useGetUser(userId!)

  return (
    <Section>
      <Container>
        <PageContent>
          {isLoading && <Loading large />}
          {isError && <PageAlert status='error' title={error.request.status === 403 ? 'Přístup odmítnut' : 'Chyba při načítání uživatele'}>
            <Stack gap={4}>
              <Button onClick={() => refetch()} colorScheme='secondary'><Refresh />Načíst znovu</Button>
              <Button onClick={() => navigate(-1)} variant='ghost'><ArrowLeft boxSize={4} /> Zpět</Button>
            </Stack>
          </PageAlert>}
          {isSuccess && <UserDetail user={data.data} />}
        </PageContent>
      </Container>
    </Section>
  )
}
